// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".three-column-text--hBiog .columns--dqLtO{row-gap:32px}.three-column-text--hBiog .subheading--HuksM{color:#5645f5}.three-column-text--hBiog .subtitle-cta--Mbu7L{color:#5645f5}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"three-column-text": "three-column-text--hBiog",
	"columns": "columns--dqLtO",
	"subheading": "subheading--HuksM",
	"subtitle-cta": "subtitle-cta--Mbu7L"
};
export default ___CSS_LOADER_EXPORT___;
